<template>
    <div v-if="$user" class="x-navbar-simple-user">
        <user-avatar></user-avatar>
        <div style="display: flex; align-items: center; margin-left: 8px" class="visible-lg-flex">
            <div>
                {{ $user.short_name }}
            </div>
            <div>
                <div class="fa fa-caret-down" style="margin-left: 8px"></div>
            </div>
        </div>
    </div>
</template>
<script>
    const UserAvatar = require('./UserAvatar.vue')

    export default {
        components: {
            UserAvatar
        },
        data () {
            return {}
        }
    }
</script>


// WEBPACK FOOTER //
// SimpleUser.vue?962b7d1a